export default __webpack_public_path__ + "static/media/Preview3.07d59f42.jpg";